import React from "react";
import { useTranslation } from "react-i18next";

import { TransactionFlag } from "fe-shared-transactions/src/types";
import { Banner } from "fe-shared/src/components";

interface Props {
  transactionFlags: TransactionFlag[];
}

const CorrectionRequestWarning = (props: Props) => {
  const { transactionFlags } = props;
  const { t } = useTranslation();

  return (
    <Banner
      variant="error"
      id="transaction-details-correction-request-warning"
      title={t("transactions.details.correctionRequest")}
    >
      {transactionFlags.map((flag) => (
        <div>{flag.text}</div>
      ))}
    </Banner>
  );
};

export default CorrectionRequestWarning;
